(function () {
  'use strict';

  const bar = document.getElementById('sticky-atc-bar');
  if (!bar) return;

  const btn      = document.getElementById('sticky-atc-btn');
  const btnText  = btn.querySelector('.sticky-atc-bar__btn-text');
  const priceEl  = document.getElementById('sticky-atc-price');
  const sectionId = bar.dataset.sectionId;

  // ── Visibility: IntersectionObserver on the original .product-form__submit ──

  const originalBtn = document.getElementById('ProductSubmitButton-' + sectionId);

  if (originalBtn) {
    const observer = new IntersectionObserver(
      function (entries) {
        const visible = entries[0].isIntersecting;
        bar.classList.toggle('is-visible', !visible);
        bar.setAttribute('aria-hidden', String(visible));
      },
      { threshold: 0, rootMargin: '0px' }
    );
    observer.observe(originalBtn);
  }

  // ── Variant sync via Dawn's pubsub ──────────────────────────────────────────

  function formatMoney(cents) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const locale   = document.documentElement.lang || 'en';
    return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
  }

  function syncVariant(variant) {
    if (!variant) return;

    // Update button state
    btn.dataset.variantId = variant.id;
    btn.disabled = !variant.available;
    btnText.textContent = variant.available
      ? window.variantStrings.addToCart
      : window.variantStrings.soldOut;

    // Update price display
    priceEl.innerHTML = '';

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const s = document.createElement('s');
      s.className = 'sticky-atc-bar__price--compare';
      s.textContent = formatMoney(variant.compare_at_price);
      priceEl.appendChild(s);
    }

    const current = document.createElement('span');
    current.className = 'sticky-atc-bar__price--current';
    current.textContent = formatMoney(variant.price);
    priceEl.appendChild(current);
  }

  // subscribe() and PUB_SUB_EVENTS are globals defined in pubsub.js / constants.js
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    if (event.data.sectionId !== sectionId) return;
    syncVariant(event.data.variant);
  });

  // ── Add to cart via fetch ────────────────────────────────────────────────────

  btn.addEventListener('click', function () {
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    const variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_add_failed');
        return res.json();
      })
      .then(function () {
        // Notify Dawn's cart (updates drawer / cart icon count)
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sticky-atc' });

        btnText.textContent = '✓ Added';
        setTimeout(function () {
          btnText.textContent = window.variantStrings.addToCart;
        }, 2000);
      })
      .catch(function () {
        btnText.textContent = window.cartStrings.error || 'Error';
        setTimeout(function () {
          btnText.textContent = window.variantStrings.addToCart;
        }, 2500);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });
})();
